/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import store from './store';
window.__store__ = store;

window.Vue = require('vue');
Vue.config.devtools = true;
Vue.config.ignoredElements = [/ya\-.*/];

import { Fragment } from "vue-fragment";
Vue.use(Fragment);


import { BootstrapVue} from 'bootstrap-vue';
Vue.use(BootstrapVue);

Vue.use(require('vue-cookies'))
Vue.$cookies.config('30d')

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// Vue.use(Vuex);


/**
 * CATALOG
 */
Vue.component('catalog-menu', require('./components/CatalogMenu.vue').default);
Vue.component('catalog-category', require('./components/CatalogCategory.vue').default);
Vue.component('catalog-items-list', require('./components/CatalogItemsList.vue').default);
Vue.component('catalog-items-grid', require('./components/CatalogItemsGrid.vue').default);
Vue.component('catalog-set', require('./components/CatalogSet.vue').default);
Vue.component('catalog-set-item', require('./components/CatalogSetItem.vue').default);
Vue.component('catalog-set-modal-related', require('./components/CatalogSetItemModalRelated.vue').default);
Vue.component('catalog-paginator', require('./components/CatalogPaginator.vue').default);

/**
 * CART
 */
Vue.component('cart', require('./components/Cart.vue').default);
Vue.component('cart-item', require('./components/CartItem.vue').default);
Vue.component('cart-counter-button', require('./components/CartCounterButton.vue').default);
Vue.component('cart-add-button', require('./components/CartAddButton.vue').default);
Vue.component('cart-add-big-button', require('./components/CartAddBigButton.vue').default);

/**
 * INFORM
 */
Vue.component('inform-button', require('./components/InformButton.vue').default);
Vue.component('inform-big-button', require('./components/InformBigButton.vue').default);
Vue.component('inform-modal', require('./components/InformModal.vue').default);
Vue.component('inform-unsubscribe-modal', require('./components/InformUnsubscribeModal.vue').default);

/**
 * FAVOURITES
 */
Vue.component('favourites-component', require('./components/FavouritesComponent.vue').default);
Vue.component('favourites-add-button', require('./components/FavouritesAddButton.vue').default);
Vue.component('favourites-add-big-button', require('./components/FavouritesAddBigButton.vue').default);
Vue.component('favourites-counter-button', require('./components/FavouritesCounterButton.vue').default);
Vue.component('favourites', require('./components/Favourites.vue').default);

/**
 * ORDER FORM
 */
Vue.component('order-form', require('./components/OrderForm.vue').default);

// Payers
Vue.component('order-form-payer', require('./components/OrderFormPayer.vue').default);
Vue.component('order-form-payer-modal', require('./components/OrderFormPayerModal.vue').default);
Vue.component('order-form-payer-items', require('./components/OrderFormPayerItems.vue').default);
Vue.component('order-form-payer-form', require('./components/OrderFormPayerForm.vue').default);

// Delivery
Vue.component('order-form-delivery', require('./components/OrderFormDelivery.vue').default);
Vue.component('order-form-delivery-method-modal', require('./components/OrderFormDeliveryMethodModal.vue').default);
Vue.component('order-form-delivery-method-items', require('./components/OrderFormDeliveryMethodItems.vue').default);
Vue.component('order-form-delivery-address-modal', require('./components/OrderFormDeliveryAddressModal.vue').default);
Vue.component('order-form-delivery-address-items', require('./components/OrderFormDeliveryAddressItems.vue').default);
Vue.component('order-form-delivery-address-form', require('./components/OrderFormDeliveryAddressForm.vue').default);
Vue.component('order-form-delivery-pickup-point-modal', require('./components/OrderFormDeliveryPickupPointModal.vue').default);
Vue.component('order-form-delivery-pickup-point-items', require('./components/OrderFormDeliveryPickupPointItems.vue').default);

// Recipients
Vue.component('order-form-recipient', require('./components/OrderFormRecipient.vue').default);
Vue.component('order-form-recipient-modal', require('./components/OrderFormRecipientModal.vue').default);

// Payment methods
Vue.component('order-form-payment-method', require('./components/OrderFormPaymentMethod.vue').default);
Vue.component('order-form-payment-method-modal', require('./components/OrderFormPaymentMethodModal.vue').default);

// Callback
Vue.component('callback-form', require('./components/CallBackForm.vue').default);

// Profile
Vue.component('profile-payer', require('./components/ProfilePayer.vue').default);
Vue.component('profile-delivery-address', require('./components/ProfileDeliveryAddress.vue').default);
Vue.component('profile-account', require('./components/ProfileAccount.vue').default);

// News
Vue.component('header-news', require('./components/HeaderNews.vue').default);

// Search
Vue.component('search-form', require('./components/SearchForm.vue').default);

/**
 * Question
 */
Vue.component('question-form', require('./components/QuestionForm.vue').default);

/**
 * Purchase Request
 */
Vue.component('purchase-request-button', require('./components/PurchaseRequestButton.vue').default);
Vue.component('purchase-request-big-button', require('./components/PurchaseRequestBigButton.vue').default);
Vue.component('purchase-request-modal', require('./components/PurchaseRequestModal.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
console.log(store);

const app = new Vue({
    el: '#app',
    store,
    mounted() {
        // this.getFavourites();
        // this.getFavouritesCount();

        this.$store.dispatch('checkAuth');
        this.$store.dispatch('cart/getCart');
    }
});


/**
 * Ещё товары в коллекции
 */
let collectionMore = document.querySelectorAll('.pagination_loadmore__collection');

for (let i = 0; i < collectionMore.length; i++) {
    let el = collectionMore[i];

    el.addEventListener('click', (event) => {
        let items = document.querySelectorAll('.catalog_gallery__collection .catalog_gallery_item');
        
        for (let j = 0; j < items.length; j++) {
            items[j].style.display = 'block';
        }

        // if (el.tagName.toLowerCase() == 'button') {
            el.style.display = 'none';
        // }

        return false;
    });
}

/**
 * Показать пароль
 */
const togglePassword = document.querySelector('#show-hide-password a');
const passwordInput = document.querySelector('#show-hide-password input');
const passwordIcon = document.querySelector('#show-hide-password i');

if (togglePassword) {
    togglePassword.addEventListener('click', function (e) {
        e.preventDefault();
        
        const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
        
        passwordInput.setAttribute('type', type);
        passwordIcon.innerHTML = type === 'password' ? 'eye' : 'eye_slash';

        return false;
    });
}